'use client'

import dynamic from 'next/dynamic'
import { ComponentProps } from 'react'
import Hyperspeed from './Hyperspeed'

const HyperspeedDynamic = dynamic(() => import('./Hyperspeed'), { ssr: false })

export default function HyperspeedWrapper(props: ComponentProps<typeof Hyperspeed>) {
    return <HyperspeedDynamic {...props} />
}
